// This file contains the fifth image of the first project

export const PortfolioImg5 = ({
  backgroundPic,
  l1,
  r1,
  l2,
  r2,
  l3,
  r3,
  desc,
}) => {
  return (
    <div className="hidden-on-mobile">
      <img
        className="project-image project-image-desktop"
        src={backgroundPic}
        alt="Image of Project"
        style={{ borderRadius: "3px", overflow: "hidden" }}
      />

      <div className="overlapping-image-1">
        <img
          className="check"
          src={l1}
          style={{ borderRadius: "25px", overflow: "hidden" }}
        />
        <img
          className="check"
          src={r1}
          style={{ borderRadius: "25px", overflow: "hidden" }}
        />
      </div>

      <div className="overlapping-image-2">
        <img
          className="check2"
          src={l2}
          style={{ borderRadius: "25px", overflow: "hidden" }}
        />
        <img
          className="check2"
          src={r2}
          style={{ borderRadius: "25px", overflow: "hidden" }}
        />
      </div>

      <div className="overlapping-image-3">
        <img
          className="check3"
          src={l3}
          style={{ borderRadius: "25px", overflow: "hidden" }}
        />
        <img
          className="check3"
          src={r3}
          style={{ borderRadius: "25px", overflow: "hidden" }}
        />
      </div>
    </div>
  );
};
